<template>
  <v-app :dark="dark">
    <not-auth-toolbar></not-auth-toolbar>
    <v-content>
      <v-container justify-center fill-height>
        <v-layout align-center justify-center column>
          <v-icon color="error" size="54">{{$vuetify.icons.error}}</v-icon>
          <p class="grey--text mb-3" style="font-size: 18px;text-indent: 35px">因疫情防控原因，车辆预约系统暂时关闭，相关预约需求请转至行人预约进行处理。</p>
        </v-layout>
      </v-container>
    </v-content>
    <app-footer></app-footer>
  </v-app>
</template>

<script>
  import AppFooter from '../APP/Footer/appFooter'
  import NotAuthToolbar from '../APP/Toolbar/notAuthToolbar'
  export default {
    name: 'VehicleReservationError',
    components: {NotAuthToolbar, AppFooter},
    computed: {
      dark () {
        return this.$store.getters.dark
      }
    },
    methods: {
      goBack () {
        window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push('/')
      },
    }
  }
</script>

<style scoped>

</style>
